import React, { useState, useMemo, useEffect } from "react";
import { Tabs } from "antd";
import TeamSkillValidation from "./components/TeamSkillValidation/TeamSkillValidation";
import { useNavigate, useParams } from "react-router-dom";
import TrainingPlansOverview from "./components/TrainingPlans/SkillsReports";
import TrainingReports from "./components/TrainingReports/TrainingReports";
import TrainingRequestsReview from "./components/TrainingRequestReview/TrainingRequestReview";
import TrainingRequestsOverview from "./components/TrainingRequestsOverview/TrainingRequestsOverview";
import FlatTitle from "../LandingPage/components/ContactUs/components/FlatTitle";
import Mouse from "../../components/Mouse/Mouse";
import ScrollTop from "../../components/ScrollTop/ScrollTop";
import EvaluationFormPage from "./components/AnnualEvaluation/EvaluationFormPage";
import TrainingFeedbacksOverview from "./components/TrainingFeedbacksOverview/TrainingFeedbacksOverview";

function DivisionManagerSpace() {
  const items = useMemo(() => [
    {
      key: "team-skill-validation",
      label: "Team Skill Validation",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <TeamSkillValidation />
        </React.Suspense> 
      ),
    },
    {
      key: "training-plans-overview",
      label: "Skills Reports",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <TrainingPlansOverview />
        </React.Suspense>
      ),
    },
    {
      key: "training-reports",
      label: "Training Reports",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <TrainingReports />
        </React.Suspense>
      ),
    },
    {
      key: "training-requests-review",
      label: "Training Requests",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <TrainingRequestsReview />
        </React.Suspense>
      ),
    },
    {
      key: "training-requests-overview",
      label: "Training Requests Overview",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <TrainingRequestsOverview />
        </React.Suspense>
      ),
    },
     {
      key: "training-feedbacks-overview",
      label: "Training Feedbacks Overview",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <TrainingFeedbacksOverview />
        </React.Suspense>
      ),
    },
    {
      key: "evaluation-form-builder",
      label: "Evaluation Form Builder",
      children: (
        <React.Suspense fallback={<div>Loading...</div>}>
          <EvaluationFormPage />
        </React.Suspense>
      ),
    }
    
  ],
    []
  );

  const getTab = (tab) => {
    if (["team-skill-validation", "training-plans-overview", "training-reports", "training-requests-review", "training-requests-overview", "training-feedbacks-overview",
     "evaluation-form-builder"
    ].includes(tab)) {
      return tab;
    }
    return "team-skill-validation";
  };

  const refactorKey = (key) => {
    return key.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  }

  const navigate = useNavigate();
  const { tab } = useParams();
  const [name, setName] = useState(getTab(tab));

  const onChangeHeaderName = (key) => {
    navigate(`../departments/${key}`);
  };

  useEffect(() => {
    setName(refactorKey(getTab(tab)));
  }, [tab]);

  return (
    <>
      <FlatTitle pageName={refactorKey(name)} />
      <div className="section-container">
        <div id="wrapper">
      <Tabs
        tabBarGutter={85}
        activeKey={getTab(tab)}
        items={items}
        onChange={onChangeHeaderName}
        className="custom-tabs"
        destroyInactiveTabPane={true}
      />
      <Mouse />
      <ScrollTop />
    </div>
      </div >
      </>
  );
}

export default DivisionManagerSpace;
